import { Users, Boxes, NotebookPen, CalendarDays, Droplets, Camera, ShieldCheck, Pause } from "lucide-react";

const TINTS = {
  stone: "text-stone-400",
  amber: "text-amber-600",
  orange: "text-orange-600",
};

function Stat({ label, value, icon: Icon, testid, tint = "stone" }) {
  return (
    <div className="bg-white border border-stone-200 rounded-2xl p-5" data-testid={testid}>
      <div className="flex items-center justify-between">
        <div className="text-xs uppercase tracking-[0.2em] text-stone-500">{label}</div>
        <Icon className={`w-4 h-4 ${TINTS[tint]}`} />
      </div>
      <div className="font-display text-4xl font-light mt-3 tabular-nums">{value}</div>
    </div>
  );
}

export default function AdminStats({ stats }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      <Stat label="Users" value={stats?.users ?? 0} icon={Users} testid="stat-users" />
      <Stat label="Hives" value={stats?.hives ?? 0} icon={Boxes} testid="stat-hives" />
      <Stat label="Journals" value={stats?.journals ?? 0} icon={NotebookPen} testid="stat-journals" />
      <Stat label="Reminders" value={stats?.events ?? 0} icon={CalendarDays} testid="stat-events" />
      <Stat label="Harvests" value={stats?.harvests ?? 0} icon={Droplets} testid="stat-harvests" />
      <Stat label="Diagnoses" value={stats?.diagnoses ?? 0} icon={Camera} testid="stat-diagnoses" />
      <Stat label="Admins" value={stats?.admins ?? 0} icon={ShieldCheck} testid="stat-admins" tint="amber" />
      <Stat label="Suspended" value={stats?.suspended ?? 0} icon={Pause} testid="stat-suspended" tint="orange" />
    </div>
  );
}
